<template>
  <div class="navbtm-container flx-row js-btw">
    <div class="btm-left flx-row fw-bd">
      <img src="static/img/logo.png" @click="navTo(0)" class="csr-pt" alt />
      <div
        class="tx-left tx-btm-tra"
        :class="activeClass==acindex?'isActive':''"
        v-for="(acitem,acindex) in $t('Layout.navList')"
        :key="acindex"
        @click="navTo(acindex)"
        @mouseenter="enterShow(acindex)"
        @mouseleave="leaveShow(acindex)"
      >
        {{acitem}}
        <el-collapse-transition>
          <div
            v-if="acindex==4"
            v-show="showContact"
            class="ct-container bg-f ps-as c-2 flx-col fw-4"
          >
            <div
              class="outter w-100"
              @click="contactUs(conindex)"
              v-for="(conitem, conindex) in $t('Layout.contactList')"
              :key="conindex"
            >
              <div class="inter">{{conitem}}</div>
            </div>
          </div>
        </el-collapse-transition>
        <el-collapse-transition>
          <div
            v-if="acindex==1"
            v-show="showShop"
            class="ct-container bg-f ps-as c-2 flx-col fw-4 tal-ct"
          >
            <div
              class="outter w-100"
              @click="toshop(shopindex)"
              v-for="(shopitem, shopindex) in $t('Layout.shopList')"
              :key="shopindex"
            >
              <div class="inter">{{shopitem}}</div>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>
    <div class="btm-right flx-row">
      <el-popover placement="bottom" trigger="hover" popper-class="popop">
        <div class="popoutter" v-if="cartList.length!==0">
          <div class="popcart-container bg-f">
            <div class="cartlist-container">
              <div
                class="eachitem flx-row"
                v-for="(cartitem,cartindex) in cartList"
                :key="cartindex"
                :class="cartindex==0?'':'mt-20'"
              >
                <img :src="cartitem.goods.small_image" alt />
                <div class="itemtext fs-14">
                  <p class="c-2 mgl-10">{{cartitem.goods.title}}</p>
                  <div class="c-ce mt-20">
                    {{$t('public.money')}}{{cartitem.goods.price}}
                    <span
                      class="c-6"
                    >x{{cartitem.number}}</span>
                  </div>
                </div>
                <img
                  src="static/img/icon_close.png"
                  alt
                  class="clsimg mgl-20 csr-pt"
                  @click="delCart(cartitem)"
                />
              </div>
            </div>
            <div>
              <div class="flx-row js-btw btm-c">
                <div class="c-2">
                  {{$t('Layout.cartGoodsTotal')}}
                  <span class="c-ce">{{cartlength}}</span>
                  {{$t('Layout.cartGoods')}}
                  <span class="mgl-10">
                    {{$t('Layout.cartPrice')}}
                    <span
                      class="c-ce"
                    >{{$t('public.money')}}{{totalPrice}}</span>
                  </span>
                </div>
                <div class="bg-e0 c-f csr-pt" @click="toCart">{{$t('Layout.buy')}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="empty-container bg-f">
            <div class="fs-14 c-9">{{cartEmpty}}</div>
          </div>
        </div>
        <div class="carbar flx-row fs-14" slot="reference">
          <img src="static/img/home_icon_search.png" alt />
          <div class="c-e0">{{$t('Layout.cart')}}</div>
          <div class="c-f">
            <p>{{cartlength}}</p>
          </div>
        </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
import store from "../../store";
import { getList, toDelGoods } from "@/api/cart";

export default {
  data() {
    return {
      activeClass: null,
      showContact: false,
      showShop: false,
      cartEmpty: "",
      // cartlength: 0,
      cartList: [],
      total: null
    };
  },
  mounted() {
    this.getCart();
  },
  watch: {
    "$store.state.conty": "getCart",
    "$store.state.cartflag": "getCart",
    "$store.state.showRegi": "getCart"
    // "$store.state.cartFlag": "getCart"
  },
  computed: {
    totalPrice() {
      var total = 0;
      for (let i = 0; i < this.cartList.length; i++) {
        total += this.cartList[i].goods.price * this.cartList[i].number;
      }
      this.total = total;
      return total;
    },
    cartlength() {
      if (this.cartList.length !== 0) {
        return this.cartList.length;
      } else {
        return 0;
      }
    }
  },
  methods: {
    toCart() {
      this.$router.push({
        name: "cart"
      });
    },
    delCart(e) {
      // console.log(e);
      let query = {
        goods_id: e.goods_id
      };
      toDelGoods(query).then(res => {
        if (res.code == 200) {
          this.$store.commit("setCartFlag", Math.random());
          this.getCart();
        }
      });
    },
    getCart() {
      this.cartEmpty = this.$t("public.noitem");
      if (localStorage.getItem("accessToken")) {
        getList({
          lang: this.$store.state.conty
        }).then(res => {
          // console.log(res);
          this.cartList = res.data.list;
        });
      } else {
        this.cartEmpty = this.$t("public.loginstatus");
      }
    },
    enterShow(e) {
      switch (e) {
        case 1:
          this.showShop = true;
          break;
        case 4:
          this.showContact = true;
          break;

        default:
          break;
      }
      // console.log('进入');
    },
    leaveShow(e) {
      switch (e) {
        case 1:
          this.showShop = false;
          break;
        case 4:
          this.showContact = false;
          break;

        default:
          break;
      }
      // console.log('出去');
    },
    navTo(e) {
      this.activeClass = e;
      switch (e) {
        case 0:
          this.$router.push({
            path: "/"
          });
          break;
        case 2:
          this.$router.push({
            path: "/exhibition"
          });
          break;
        case 3:
          this.$router.push({
            path: "/news"
          });
          break;

        default:
          break;
      }
    },
    contactUs(val) {
      this.$router.push({
        name: "contact",
        params: {
          type: val
        }
      });
      this.$store.commit("changeCType", val);
    },
    toshop(val) {
      switch (val) {
        case 0:
          this.$router.push({
            name: "activity"
          });
          break;
        case 1:
          this.$router.push({
            name: "shop"
          });
          break;
        case 2:
          this.$router.push({
            name: "halfprice"
          });
          break;

        default:
          break;
      }
    }
  }
};
</script>
<style lang="scss">
.popop {
  padding: 0;
  box-shadow: none;
  border: 0.0625rem solid #e09e0b;
  border-radius: 0;
  .popper__arrow {
    border-bottom-color: #e09e0b !important;
  }
}
</style>

<style lang="scss" scoped>
.navbtm-container {
  padding: 0 22.8125rem;
  border-bottom: 0.0625rem solid #d8d8d8;
  .tx-left {
    box-sizing: border-box;
    padding: 3.125rem 0;
    margin-left: 2.1875rem;
    cursor: pointer;
  }
  .isActive {
    color: #e09e0b;
    border-bottom: 0.3125rem solid #e09e0b !important;
  }
  .tx-left:hover {
    color: #e09e0b;
    border-bottom: 0.3125rem solid #e09e0b;
  }
  .tx-btm {
    border-bottom: 0.3125rem solid #e09e0b;
  }
  .tx-btm-tra {
    border-bottom: 0.3125rem solid transparent;
  }
  .searchbar {
    border-left: 0.0625rem solid #e09e0b;
    border-bottom: 0.0625rem solid #e09e0b;
    border-top: 0.0625rem solid #e09e0b;
    box-sizing: border-box;
    border-radius: 1.25rem;
    padding: 0 0 0 1.25rem;
    margin-right: 1.875rem;
    .fs-16 {
      background: #e09e0b;
      color: #fff;
      border-top-right-radius: 1.25rem;
      border-bottom-right-radius: 1.25rem;
      border-right: 0.0625rem solid #e09e0b;
      padding: 0.625rem 1.25rem;
    }

    input {
      font-size: 0.875rem;
      border: none;
      height: 100%;
      margin-left: 0.625rem;
    }
    input:focus {
      outline: none;
    }
    ::-webkit-input-placeholder {
      /* WebKit browsers */
      color: #999;
      font-size: 0.875rem;
    }
    :-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #999;
      font-size: 0.875rem;
    }
    ::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #999;
      font-size: 0.875rem;
    }
    :-ms-input-placeholder {
      /* Internet Explorer 10+ */
      color: #999;
      font-size: 0.875rem;
    }
  }
  .carbar {
    cursor: pointer;
    padding: 0.625rem;
    border-radius: 1.25rem;
    border: 0.0625rem solid #e09e0b;
    .c-e0 {
      margin-left: 0.625rem;
      margin-right: 1.25rem;
    }
    .c-f {
      border-radius: 50%;
      text-align: center;
      background: #ce1616;
      height: 1.25rem;
      width: 1.25rem;
    }
  }
  .ct-container {
    margin-top: 55px;
    box-shadow: 0 0.125rem 1.4375rem 0 rgba(0, 0, 0, 0.1);
    z-index: 2000;
    border-radius: 0.0625rem;
    width: fit-content;
    padding: 0.5rem 0;
    .outter {
      padding: 0.625rem 0;
      .inter {
        padding: 0 1.375rem;
      }
    }
    .outter:hover {
      background: #eee;
      color: #666;
    }
  }
}

.popoutter {
  overflow: hidden;
  .popcart-container::-webkit-scrollbar {
    display: none;
  }
  .popcart-container {
    height: 18.75rem;
    overflow-x: hidden;
    overflow-y: scroll;
    .cartlist-container {
      padding: 1.25rem 1.25rem 6.25rem 1.25rem;
      .eachitem {
        img {
          width: 3.75rem;
          height: 4.375rem;
        }
        .itemtext {
          .c-2 {
            width: 11.25rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
        .clsimg {
          width: 0.6875rem;
          height: 0.6875rem;
        }
      }
    }
    .btm-c {
      // margin-top: 6.25rem;
      position: absolute;
      bottom: 0;
      width: 100%;
      box-sizing: border-box;
      background: #f0f0f0;
      padding: 0.3125rem 0.625rem;
      .c-2 {
      }
      .c-f {
        padding: 0.5rem 0.8125rem;
      }
    }
  }
}
.empty-container {
  padding: 1.25rem;
}
</style>



// WEBPACK FOOTER //
// src/views/navbar/navbottom.vue